import { render } from "./ImportWallet.vue?vue&type=template&id=970e5842"
import script from "./ImportWallet.vue?vue&type=script&lang=ts"
export * from "./ImportWallet.vue?vue&type=script&lang=ts"

import "./ImportWallet.vue?vue&type=style&index=0&id=970e5842&lang=scss"
script.render = render

export default script